const HOMEPAGE_ENDPOINT = 'https://photographer000.wpdevcloud.com/wp-json/wp/v2/homepage/28';
const ABOUT_PAGE_ENDPOINT = 'https://photographer000.wpdevcloud.com/wp-json/wp/v2/about_page/36';
const SERVICES_PAGE_ENDPOINT = 'https://photographer000.wpdevcloud.com/wp-json/wp/v2/services_page/38';
const PROJECTS_PAGE_ENDPOINT = 'https://photographer000.wpdevcloud.com/wp-json/wp/v2/projects_page/40';
const GALLERY_PAGE_ENDPOINT = 'https://photographer000.wpdevcloud.com/wp-json/wp/v2/gallery_page/42';
const CONTACT_PAGE_ENDPOINT = 'https://photographer000.wpdevcloud.com/wp-json/wp/v2/contact_page/44';
const GLOBAL_SETTINGS_ENDPOINT = 'https://photographer000.wpdevcloud.com/wp-json/wp/v2/global_settings/46';

let globalSettingsRequest;

function decodeHtmlEntities(value) {
  if (typeof value !== 'string') {
    return value;
  }

  const textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
}

function getScalarValue(meta, fieldName, fallback) {
  const value = meta?.[fieldName];

  if (typeof value !== 'string' || value.trim() === '') {
    return fallback;
  }

  return decodeHtmlEntities(value);
}

function normalizeRepeaterObject(value, mapItem, isValidItem) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return [];
  }

  return Object.entries(value)
    .filter(([key, item]) => (
      /^item-\d+$/.test(key) &&
      item &&
      typeof item === 'object' &&
      !Array.isArray(item)
    ))
    .sort(([firstKey], [secondKey]) => (
      Number(firstKey.replace('item-', '')) -
      Number(secondKey.replace('item-', ''))
    ))
    .map(([, item]) => mapItem(item))
    .filter(isValidItem);
}

export function normalizeProjectsRepeater(value) {
  return normalizeRepeaterObject(
    value,
    (item) => ({
      image: getScalarValue(item, 'image', ''),
      title: getScalarValue(item, 'title', ''),
      category: getScalarValue(item, 'category', ''),
      description: getScalarValue(item, 'description', ''),
      show_on_homepage: item.show_on_homepage === true ||
        item.show_on_homepage === 'true' ||
        item.show_on_homepage === 1 ||
        item.show_on_homepage === '1',
    }),
    (item) => item.image || item.title || item.category || item.description,
  );
}

export function normalizeServicesRepeater(value) {
  return normalizeRepeaterObject(
    value,
    (item) => ({
      number: getScalarValue(item, 'number', ''),
      title: getScalarValue(item, 'title', ''),
      description: getScalarValue(item, 'description', ''),
      image: getScalarValue(item, 'image', ''),
    }),
    (item) => item.number || item.title || item.description || item.image,
  );
}

export function normalizeProcessStepsRepeater(value) {
  return normalizeRepeaterObject(
    value,
    (item) => ({
      number: getScalarValue(item, 'number', ''),
      title: getScalarValue(item, 'title', ''),
      description: getScalarValue(item, 'description', ''),
    }),
    (item) => item.number || item.title || item.description,
  );
}

export async function fetchHomepageScalars() {
  const response = await fetch(HOMEPAGE_ENDPOINT);

  if (!response.ok) {
    throw new Error(`Homepage request failed with status ${response.status}`);
  }

  const data = await response.json();
  return data?.meta || {};
}

export function mapHomepageScalars(meta, fallback) {
  return {
    hero: {
      eyebrow: getScalarValue(meta, 'hero_eyebrow', fallback.hero.eyebrow),
      heading: getScalarValue(meta, 'hero_heading', fallback.hero.heading),
      description: getScalarValue(meta, 'hero_description', fallback.hero.description),
      heroImage: getScalarValue(meta, 'hero_image', fallback.hero.heroImage),
      primaryCtaLabel: getScalarValue(meta, 'hero_primary_cta_label', fallback.hero.primaryCtaLabel),
      primaryCtaUrl: getScalarValue(meta, 'hero_primary_cta_url', fallback.hero.primaryCtaUrl),
      secondaryCtaLabel: getScalarValue(meta, 'hero_secondary_cta_label', fallback.hero.secondaryCtaLabel),
      secondaryCtaUrl: getScalarValue(meta, 'hero_secondary_cta_url', fallback.hero.secondaryCtaUrl),
    },
    about: {
      eyebrow: getScalarValue(meta, 'about_eyebrow', fallback.about.eyebrow),
      heading: getScalarValue(meta, 'about_heading', fallback.about.heading),
      description: getScalarValue(meta, 'about_description', fallback.about.description),
      aboutImage: getScalarValue(meta, 'about_image', fallback.about.aboutImage),
      body: getScalarValue(meta, 'about_body', fallback.about.body),
      linkLabel: getScalarValue(meta, 'about_link_label', fallback.about.linkLabel),
      linkUrl: getScalarValue(meta, 'about_link_url', fallback.about.linkUrl),
    },
    services: {
      eyebrow: getScalarValue(meta, 'services_eyebrow', fallback.services.eyebrow),
      heading: getScalarValue(meta, 'services_heading', fallback.services.heading),
      description: getScalarValue(meta, 'services_description', fallback.services.description),
      ctaLabel: getScalarValue(meta, 'services_cta_label', fallback.services.ctaLabel),
      ctaUrl: getScalarValue(meta, 'services_cta_url', fallback.services.ctaUrl),
    },
    projects: {
      eyebrow: getScalarValue(meta, 'projects_eyebrow', fallback.projects.eyebrow),
      heading: getScalarValue(meta, 'projects_heading', fallback.projects.heading),
      linkLabel: getScalarValue(meta, 'projects_link_label', fallback.projects.linkLabel),
      linkUrl: getScalarValue(meta, 'projects_link_url', fallback.projects.linkUrl),
    },
    philosophy: {
      eyebrow: getScalarValue(meta, 'philosophy_eyebrow', fallback.philosophy.eyebrow),
      heading: getScalarValue(meta, 'philosophy_heading', fallback.philosophy.heading),
      body: getScalarValue(meta, 'philosophy_body', fallback.philosophy.body),
      philosophyImage: getScalarValue(meta, 'philosophy_image', fallback.philosophy.philosophyImage),
      linkLabel: getScalarValue(meta, 'philosophy_link_label', fallback.philosophy.linkLabel),
      linkUrl: getScalarValue(meta, 'philosophy_link_url', fallback.philosophy.linkUrl),
    },
    gallery: {
      eyebrow: getScalarValue(meta, 'gallery_eyebrow', fallback.gallery.eyebrow),
      heading: getScalarValue(meta, 'gallery_heading', fallback.gallery.heading),
      linkLabel: getScalarValue(meta, 'gallery_link_label', fallback.gallery.linkLabel),
      linkUrl: getScalarValue(meta, 'gallery_link_url', fallback.gallery.linkUrl),
    },
    testimonials: {
      eyebrow: getScalarValue(meta, 'testimonials_eyebrow', fallback.testimonials.eyebrow),
      heading: getScalarValue(meta, 'testimonials_heading', fallback.testimonials.heading),
    },
    closingCta: {
      eyebrow: getScalarValue(meta, 'closing_cta_eyebrow', fallback.closingCta.eyebrow),
      heading: getScalarValue(meta, 'closing_cta_heading', fallback.closingCta.heading),
      description: getScalarValue(meta, 'closing_cta_description', fallback.closingCta.description),
      label: getScalarValue(meta, 'closing_cta_label', fallback.closingCta.label),
      url: getScalarValue(meta, 'closing_cta_url', fallback.closingCta.url),
    },
  };
}

export async function fetchAboutPageScalars() {
  const response = await fetch(ABOUT_PAGE_ENDPOINT);

  if (!response.ok) {
    throw new Error(`About Page request failed with status ${response.status}`);
  }

  const data = await response.json();
  return data?.meta || {};
}

export function mapAboutPageScalars(meta, fallback) {
  return {
    hero: {
      eyebrow: getScalarValue(meta, 'hero_eyebrow', fallback.hero.eyebrow),
      heading: getScalarValue(meta, 'hero_heading', fallback.hero.heading),
      description: getScalarValue(meta, 'hero_description', fallback.hero.description),
      heroImage: getScalarValue(meta, 'hero_image', fallback.hero.heroImage),
    },
    story: {
      eyebrow: getScalarValue(meta, 'story_eyebrow', fallback.story.eyebrow),
      heading: getScalarValue(meta, 'story_heading', fallback.story.heading),
      lead: getScalarValue(meta, 'story_lead', fallback.story.lead),
      body: getScalarValue(meta, 'story_body', fallback.story.body),
    },
    imageStory: {
      image: getScalarValue(meta, 'image_story_image', fallback.imageStory.image),
      caption: getScalarValue(meta, 'image_story_caption', fallback.imageStory.caption),
    },
    principles: {
      eyebrow: getScalarValue(meta, 'principles_eyebrow', fallback.principles.eyebrow),
      heading: getScalarValue(meta, 'principles_heading', fallback.principles.heading),
    },
    statement: {
      text: getScalarValue(meta, 'statement_text', fallback.statement.text),
      attribution: getScalarValue(meta, 'statement_attribution', fallback.statement.attribution),
    },
    closingCta: {
      eyebrow: getScalarValue(meta, 'closing_cta_eyebrow', fallback.closingCta.eyebrow),
      heading: getScalarValue(meta, 'closing_cta_heading', fallback.closingCta.heading),
      label: getScalarValue(meta, 'closing_cta_label', fallback.closingCta.label),
      url: getScalarValue(meta, 'closing_cta_url', fallback.closingCta.url),
    },
  };
}

export async function fetchServicesPageScalars() {
  const response = await fetch(SERVICES_PAGE_ENDPOINT);

  if (!response.ok) {
    throw new Error(`Services Page request failed with status ${response.status}`);
  }

  const data = await response.json();
  return data?.meta || {};
}

export function mapServicesPageScalars(meta, fallback) {
  const serviceItems = normalizeServicesRepeater(meta?.services);
  const processSteps = normalizeProcessStepsRepeater(meta?.process_steps);

  return {
    hero: {
      eyebrow: getScalarValue(meta, 'hero_eyebrow', fallback.hero.eyebrow),
      heading: getScalarValue(meta, 'hero_heading', fallback.hero.heading),
      description: getScalarValue(meta, 'hero_description', fallback.hero.description),
    },
    services: serviceItems.length > 0 ? serviceItems : fallback.services,
    process: {
      eyebrow: getScalarValue(meta, 'process_eyebrow', fallback.process.eyebrow),
      heading: getScalarValue(meta, 'process_heading', fallback.process.heading),
    },
    processSteps: processSteps.length > 0
      ? processSteps
      : fallback.processSteps,
    closingCta: {
      eyebrow: getScalarValue(meta, 'closing_cta_eyebrow', fallback.closingCta.eyebrow),
      heading: getScalarValue(meta, 'closing_cta_heading', fallback.closingCta.heading),
      label: getScalarValue(meta, 'closing_cta_label', fallback.closingCta.label),
      url: getScalarValue(meta, 'closing_cta_url', fallback.closingCta.url),
    },
  };
}

export async function fetchProjectsPageScalars() {
  const response = await fetch(PROJECTS_PAGE_ENDPOINT);

  if (!response.ok) {
    throw new Error(`Projects Page request failed with status ${response.status}`);
  }

  const data = await response.json();
  return data?.meta || {};
}

export function mapProjectsPageScalars(meta, fallback) {
  const projects = normalizeProjectsRepeater(meta?.projects);

  return {
    hero: {
      eyebrow: getScalarValue(meta, 'hero_eyebrow', fallback.hero.eyebrow),
      heading: getScalarValue(meta, 'hero_heading', fallback.hero.heading),
      description: getScalarValue(meta, 'hero_description', fallback.hero.description),
    },
    projects: projects.length > 0 ? projects : fallback.projects,
  };
}

export async function fetchGalleryPageScalars() {
  const response = await fetch(GALLERY_PAGE_ENDPOINT);

  if (!response.ok) {
    throw new Error(`Gallery Page request failed with status ${response.status}`);
  }

  const data = await response.json();
  return data?.meta || {};
}

export function mapGalleryPageScalars(meta, fallback) {
  return {
    hero: {
      eyebrow: getScalarValue(meta, 'hero_eyebrow', fallback.hero.eyebrow),
      heading: getScalarValue(meta, 'hero_heading', fallback.hero.heading),
      description: getScalarValue(meta, 'hero_description', fallback.hero.description),
    },
  };
}

export async function fetchContactPageScalars() {
  const response = await fetch(CONTACT_PAGE_ENDPOINT);

  if (!response.ok) {
    throw new Error(`Contact Page request failed with status ${response.status}`);
  }

  const data = await response.json();
  return data?.meta || {};
}

export function mapContactPageScalars(meta, fallback) {
  return {
    eyebrow: getScalarValue(meta, 'contact_eyebrow', fallback.eyebrow),
    heading: getScalarValue(meta, 'contact_heading', fallback.heading),
    description: getScalarValue(meta, 'contact_description', fallback.description),
    contactImage: getScalarValue(meta, 'contact_image', fallback.contactImage),
    imageCaption: getScalarValue(meta, 'contact_image_caption', fallback.imageCaption),
  };
}

export function fetchGlobalSettingsScalars() {
  if (!globalSettingsRequest) {
    globalSettingsRequest = fetch(GLOBAL_SETTINGS_ENDPOINT)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Global Settings request failed with status ${response.status}`);
        }

        return response.json();
      })
      .then((data) => data?.meta || {});
  }

  return globalSettingsRequest;
}

export function mapGlobalSettingsScalars(meta, fallback) {
  return {
    brandMark: getScalarValue(meta, 'brand_mark', fallback.brandMark),
    brandName: getScalarValue(meta, 'brand_name', fallback.brandName),
    brandDescriptor: getScalarValue(meta, 'brand_descriptor', fallback.brandDescriptor),
    headerCtaLabel: getScalarValue(meta, 'header_cta_label', fallback.headerCtaLabel),
    headerCtaUrl: getScalarValue(meta, 'header_cta_url', fallback.headerCtaUrl),
    studioAddress: getScalarValue(meta, 'studio_address', fallback.studioAddress),
    contactEmail: getScalarValue(meta, 'contact_email', fallback.contactEmail),
    contactPhone: getScalarValue(meta, 'contact_phone', fallback.contactPhone),
    footerDescription: getScalarValue(meta, 'footer_description', fallback.footerDescription),
    footerHeading: getScalarValue(meta, 'footer_heading', fallback.footerHeading),
    copyrightText: getScalarValue(meta, 'copyright_text', fallback.copyrightText),
    footerLocation: getScalarValue(meta, 'footer_location', fallback.footerLocation),
  };
}